import { CHANGE_LOCALE } from '../constants';

const DEFAULT_STATE = {
    locale: 'en',
  };

const SettingsReducer = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CHANGE_LOCALE:
            return { ...state, locale: action.data };
    
        default:
            return state;
    }
}

export default SettingsReducer
